/**
 * Picks v2 or v1 of the Subcategory edit page based on the redesign flag.
 * Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import SubCategoryAddEditPage   from './SubCategoryAddEditPage';
import SubCategoryAddEditPageV2 from './SubCategoryAddEditPageV2';

export default function SubCategoryAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? SubCategoryAddEditPageV2 : SubCategoryAddEditPage;
  return <Component {...props} />;
}
